// removed by extract-text-webpack-plugin
module.exports = {"Content":"Layout__Content__1tVtC","Layout":"Layout__Layout__1XZBx","LayoutOld":"Layout__LayoutOld__2RarF"};


//////////////////
// WEBPACK FOOTER
// ./client/src/hoc/Layout/Layout.css
// module id = 297
// module chunks = 0